<div class="idea small" data-id="{{ idea._id }}">
  <img alt class="idea-image" [src]="thumbnailImage" />
  <h3 class="text-marked unpublished" *ngIf="!idea.published">Unpublished</h3>
  <br />
  <h3 class="text-marked">{{ idea.title }}</h3>
  <div class="idea-menu">
    <p
      class="btn btn-primary fa fa-eye"
      (click)="openIdea()"
      title="View Project"></p>
    <p
      *ngIf="permissions.session.data.ideas.publish(session, idea)"
      class="btn btn-primary fa fa-sun-o"
      (click)="publish()"
      title="Publish Project"></p>
    <p
      *ngIf="permissions.session.data.ideas.unpublish(session, idea)"
      class="btn btn-primary fa fa-moon-o"
      (click)="unpublish()"
      title="Unpublish Project"></p>
  </div>
</div>
